import React from 'react';
import { Alert, Link } from '@mui/material';
import { useSync } from '../../context/SyncContext';

/** Where the app lives now, and the old address it moved from. */
export const APP_ORIGIN = 'https://app.mangrovecollect.org';
const OLD_HOSTS = ['mangrove-collect.onrender.com'];

const changes = (n) => `${n} change${n === 1 ? '' : 's'}`;

/**
 * Notice on the old address. Saved data and unsynced changes belong to the
 * address they were made on, so people sync here before moving over, then
 * sign in at the new address (and reinstall the app from there).
 */
const MovedBanner = () => {
  const { pending } = useSync();
  if (!OLD_HOSTS.includes(window.location.hostname)) return null;
  return (
    <Alert severity="info" sx={{ borderRadius: 0, py: 0.25 }} role="status">
      <strong>MangroveCollect has moved to app.mangrovecollect.org.</strong>{' '}
      {pending > 0 ? (
        `${changes(pending)} on this device haven't synced yet: sync them here first, as they don't move with you.`
      ) : (
        <>
          Sign in there, and if you installed the app, install it again from the new address.{' '}
          <Link href={`${APP_ORIGIN}/`} color="inherit" sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
            Open the new address
          </Link>
        </>
      )}
    </Alert>
  );
};

export default MovedBanner;
